import { useTranslation } from 'react-i18next';

import { Embeddings } from '@/components/Embeddings';

const DataSourcePage = () => {
  const { t } = useTranslation();

  return <Embeddings />;
};

export default DataSourcePage;
